import React from 'react';

import { useClassnames } from '@lumapps/classnames';
import { Alignment, FlexBox, Orientation, Size } from '@lumapps/lumx/react';
import { useTranslate } from '@lumapps/translations';

import { NAVIGATION_ADMIN } from '../../keys';
import { AvailableFilters } from '../../types';
import { GroupFilter } from './GroupFilter';
import { HideFilteredItemsSwitch } from './HideFilteredItemsSwitch';
import { LanguageFilter } from './LanguageFilter';

const CLASSNAME = 'navigation-list-filters';

export interface NavigationListFiltersProps {
    /** The filters to display */
    displayedFilters?: { [key in AvailableFilters]?: boolean };
    /** The languages available to filter in */
    languages: Array<string>;
}

/**
 * Navigation list filters component.
 * Contains all the filters elements to interact with the navigation list.
 */
export const NavigationListFilters: React.FC<NavigationListFiltersProps> = ({ displayedFilters, languages }) => {
    const { block } = useClassnames(CLASSNAME);
    const { translateKey } = useTranslate();

    if (!displayedFilters) {
        return null;
    }

    return (
        <FlexBox className={block()} orientation={Orientation.horizontal} hAlign={Alignment.center} gap={Size.regular}>
            {displayedFilters?.language && languages.length > 0 && (
                <LanguageFilter languages={languages} label={translateKey(NAVIGATION_ADMIN.FILTER_SHOW_IN)} />
            )}
            {displayedFilters?.group && (
                <GroupFilter
                    label={displayedFilters?.language ? translateKey(NAVIGATION_ADMIN.FILTER_AS) : undefined}
                />
            )}
            {displayedFilters?.hideFiltered && <HideFilteredItemsSwitch />}
        </FlexBox>
    );
};
